<template>
	<div class="ReActionLabel" :class="[{'my_borders':showBordes}]" v-if="!bIsDelited">
		<div class="mr-2 d-flex">
			<p class="mr-2 mb-0">ID {{bpId}} </p>
			<label v-if="labelGoTo == ''" class="col-form-label">{{label}}</label>
			<router-link v-else :to="labelGoTo">{{label}}</router-link>
			<img v-if="no_manual_start==1" src="/img/icons/donottouth.svg" style="width:20pt;height:20pt;margin-left: auto;"/>
		</div>
		<div class="d-flex align-items-center">
			<p class="mr-3 mb-0" v-if="profileCode == 0">	{{ profileCode }}</p>
			<p class="mr-3 mb-0">	{{getBPProlifeName(profileCode) }}</p>
			<div class="actions">
				<template v-for="(action,act_index) in  masActions">
					<base-switch v-if="action.actionType == 'switcher'" :key="act_index"
						v-model="action.action_model"
						type="primary"
						:on-text="action.label_on"
						:off-text="action.label_off"
						@change="DoApi(action)"
					></base-switch>
					<button v-if="action.actionType == 'btn_custom'" :key="act_index" class="ml-3 btn btn-icon btn-simple btn-warning" @click="DoApi(action)">
						<i class="tim-icons" :class="action.icon"></i>
					</button>
					<button v-if="action.actionType == 'btn_edit'" :key="act_index" class="ml-3 btn btn-icon btn-simple btn-primary" @click="DoApi(action)">
						<i class="tim-icons icon-pencil"></i>
					</button>
					<button v-if="action.actionType == 'btn_del'" :key="act_index" class="ml-3 btn btn-icon btn-simple btn-danger" @click="DoApi(action)">
						<i class="tim-icons icon-trash-simple"></i>
					</button>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	/*
		[{
			actionType: 'switcher',
			action_model: false,
			label_on: 'Вкл',
			label_off: 'Выкл',
			onClickApi: {apiMethod:'ENABLE_DISABLE',apiParam:{obj:'BP'}},
		},
		{
			actionType: 'btn_custom',
			icon: 'icon-settings-gear-63',
			onClickApi: {apiMethod:'COSTOM_ACTION',apiParam:{obj:'BP'}},
		},
		{
			actionType: 'btn_edit',
			onClickApi: {apiMethod:'GOTO',apiParam:{obj:'local',to:'/data/settings/bp_editor/id/1/edit'}},
		},
		{
			actionType: 'btn_del',
			onClickApi: {apiMethod:'DEL_ACTION',apiParam:{obj:'BP'}},
		}],
	*/
	import { BaseSwitch } from 'src/components/index';
	import swal from 'sweetalert2';
	export default {
		name: 'ReActionLabel',
		components: {
			BaseSwitch
		},
		props: {
			label: String,
			labelGoTo: {
				type:String,
				default: ''
			},
			masActions: Array,
			showBordes: {
				type: Boolean,
				default: true
			},
			no_manual_start: {
				type: Number,
				default: 0
			},
			profileCode: [String, Number],
			bpProfiles:  Array,
			bpId: Number,
		},
		data () {
			return {
				ver: 1,
				bIsDelited: false,
				
			}
		},
		computed: {
			// getBPProlifeName: function(){
			// 	let staffProfile_id = this.profileCode;
			// 	// console.log('staffProfile_id', staffProfile_id);
			// 	for (let i = 1; i < this.bpProfiles.length; i++) {
			// 		// if(this.bpProfiles[i].label){
			// 		// 	console.log(this.bpProfiles[i].label);
			// 		// }
			// 		// console.log(this.bpProfiles[i].label);
					
			// 		if(staffProfile_id ==  this.bpProfiles[i].value){
			// 			// return this.bpProfiles[i].label;
			// 			console.log(this.bpProfiles[i].label);
			// 		}else {return this.bpProfiles[i].value;}
			// 	}
				
			// }

		},
		methods: {
			DoApi(allAction){
				if(this.$GVO.isEmpty(allAction.onClickApi)) return false;
				if(allAction.onClickApi.apiMethod == 'GOTO' && allAction.onClickApi.apiParam.obj == 'local'){
					this.$router.push({path: allAction.onClickApi.apiParam.to});
				}else{
					this.$GVO.ApiCall(allAction.onClickApi.apiMethod,allAction.onClickApi.apiParam)
					.then((objApi) => {
						if(objApi.success === true){
							//console.log(objApi);
							if(allAction.actionType=='btn_del'){
								// swal({
								// 	title: 'Ошибка корректировки',
								// 	buttonsStyling: false,
								// 	confirmButtonClass: 'btn btn-danger btn-fill',
								// 	text:`${objApi.msg}`,
								// });
								this.bIsDelited=true;
							}
							if(allAction.onClickApi.apiMethod == 'export_bp'){
								let a = document.createElement("a");
								let file = new Blob([JSON.stringify(objApi.data)], {type: 'text/plain'});
								a.href = URL.createObjectURL(file);
								a.download = allAction.onClickApi.apiParam.flt.bp_id+'.json';
								a.click();
							}
						}
					}).catch(errorObjApi => console.error(errorObjApi));
				}
			},
			getBPProlifeName(profileCode){
				
				for (let i = 0; i < this.bpProfiles.length; i++) {
					let profilename = '';
					if(profileCode ==  this.bpProfiles[i].value){
						return profilename =  this.bpProfiles[i].label;
						// console.log(this.bpProfiles[i].label);
					}//else {return profilename = '0';}
				}
				
			}
		},		
		mounted() {
			// this.getBPProlifeName(this.profileCode);
		}
	}
</script>
<style>
	.ReActionLabel{
		display: flex;
		align-items: baseline;
		justify-content: space-between;
		padding: 0px 5px;
	}
	.ReActionLabel.my_borders{
		border-bottom: 1px solid #01B0E0;
		padding: 5px 5px !important;
	}

	.ReActionLabel label{
		font-weight: bold;
		font-size: 14px;
	}
	
	.ReActionLabel > div:nth-child(2){
		min-width:250px;
	}

	.ReActionLabel .bootstrap-switch{width: 70px !important; margin: 0;}
	.ReActionLabel .bootstrap-switch .bootstrap-switch-label{left: 55%;}
	.ReActionLabel .bootstrap-switch-container{width: 106px !important;}

	/*===media===============================*/
@media (max-width: 768px) {	
	.ReActionLabel {
		flex-wrap: wrap;
	}
}
</style>
